import { render, staticRenderFns } from "./PrimaryInsurance.vue?vue&type=template&id=1aed0a3e&scoped=true&"
import script from "./PrimaryInsurance.vue?vue&type=script&lang=js&"
export * from "./PrimaryInsurance.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryInsurance.vue?vue&type=style&index=0&id=1aed0a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed0a3e",
  null
  
)

export default component.exports